import { ResultStage } from 'api/StudentLoanApi';

export enum StudentLoanEligibilityResult {
  Eligible = 'eligible',
  NotEligible = 'notEligible',
  Error = 'error',
  SessionExpired = 'sessionExpired',
}

export enum LaterScreenResult {
  UploadNow = 'uploadNow',
  Done = 'done',
}

export enum BlockedScreenResult {
  UploadNewFile = 'uploadNewFile',
  Done = 'done',
}

export enum EstimateScreenResult {
  Refine = 'refine',
  NotNow = 'notNow',
}

export enum PlanScreenResult {
  SeeSteps = 'seeSteps',
  Done = 'done',
}

export enum UploadLoanInformationResult {
  NotNow = 'NotNow',
}

/**
 * Screens that save answers or a file pass `ResultStage` (the stage the calculator returned) to the router,
 * which decides where the borrower goes next.
 */
export type StudentLoanForgivenessResults =
  | ResultStage
  | StudentLoanEligibilityResult
  | LaterScreenResult
  | BlockedScreenResult
  | EstimateScreenResult
  | PlanScreenResult
  | UploadLoanInformationResult;
